import React from 'react'
import { useAPIContext } from '../../context/api'
import { VideoAPI } from '../../../../constructs/video-processing/interface'
import { PosterAPI } from '../../../../constructs/poster-processing/interface'
import { v4 as uuidv4 } from 'uuid'

export const useUploadMedia = () => {
  const { callEndpoint } = useAPIContext()

  const uploadPoster = React.useCallback(
    async (fileType: 'image', fileExtension: string, file: File, videoId: string) => {
      try {
        if (!file || !file.type) {
          throw new Error('Archivo no válido o tipo de archivo no especificado.')
        }

        if (!videoId) {
          throw new Error('ID de video no válido.')
        }

        const mode = 'optimize';
        const path = `/${mode}/${videoId}`;

        const response = await callEndpoint<PosterAPI, 'post'>('upload', path, 'POST', {
          fileType,
          fileExtension,
        })

        if (!response) {
          throw new Error('Error al obtener URL prefirmada')
        }

        const { uploadUrl, fileKey } = response

        const s3Response = await fetch(uploadUrl, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type,
          },
        })

        if (!s3Response.ok) {
          const errorText = await s3Response.text()
          throw new Error(`Error subiendo archivo a S3: ${s3Response.status} - ${errorText}`)
        }

        return {
          fileKey,
          videoId,
          path: path,
        }
      } catch (error) {
        console.error('Hook | Error al subir el poster:', error)
      }
    },
    [callEndpoint],
  )

  const uploadVideo = React.useCallback(
    async (fileType: 'video', fileExtension: string, file: File) => {
      try {
        if (!file || !file.type) {
          throw new Error('Archivo no válido o tipo de archivo no especificado.')
        }

        const fileName = uuidv4();
        const mode = 'optimize';
        const path = `/video/${mode}/${fileName}`;

        const response = await callEndpoint<VideoAPI, 'post'>('upload', path, 'POST', {
          fileType,
          fileExtension,
        })

        const { uploadUrl, fileKey } = response

        const s3Response = await fetch(uploadUrl, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type,
          },
        })

        if (!s3Response.ok) {
          const errorText = await s3Response.text()
          throw new Error(`Error subiendo archivo a S3: ${s3Response.status} - ${errorText}`)
        }

        return {
          fileKey,
          fileName,
          path: path,
          videoId: fileName,
        }
      } catch (error) {
        console.error('Hook | Error al subir el video:', error)
      }
    },
    [callEndpoint],
  )

  return { uploadVideo, uploadPoster }
}